import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { AppointmentCalendarEvent } from '../../../types';
import { EventCardWrapper } from '../../column-events/event-card-wrapper';

interface Props {
  event: AppointmentCalendarEvent;
}
export const AppointmentEvent = ({ event }: Props) => {
  return (
    <EventCardWrapper eventType={'appointment'} containerStyle={containerStyle}>
      {event.eventType}
    </EventCardWrapper>
  );
};

const containerStyle = css({
  padding: theme.spacing(0.5),
  borderRadius: theme.borderRadius.small,
  background: theme.colors.white,
  boxShadow: theme.shadows.light,
});
